export default __webpack_public_path__ + "static/media/Streetlight.d0f93888.png";